<script setup lang="ts">
import { computed, ref } from 'vue'
import { AccessPointsUtil, type AccessPointLevel } from '@/util/access_points'
import { toolkitUrls } from '@/util/links'

const props = defineProps<{
  uuid: string
  level: AccessPointLevel
}>()

const text = defineModel<string>('text', { required: true })

const HEADER_CLASSES: Record<AccessPointLevel, string> = {
  [AccessPointsUtil.valuesMap.GRADE_LEVEL]: 'bg-primary-400 text-white',
  [AccessPointsUtil.valuesMap.APPROACHING]: 'bg-blue-100 text-gray-900',
  [AccessPointsUtil.valuesMap.DEVELOPING]: 'bg-gray-100 text-gray-900'
}

const isExpanded = ref(true)
const levelLabel = computed(() => AccessPointsUtil.labelsMap[props.level])
const bodyId = computed(() => `${props.uuid}-body`)
</script>

<template>
  <section class="mb-4 border border-gray-400 rounded-xs">
    <h3>
      <button
        type="button"
        class="w-full flex items-center justify-between px-4 py-3 text-lg text-left focus-visible:outline-primary-400"
        :class="HEADER_CLASSES[level]"
        :aria-expanded="isExpanded"
        :aria-controls="bodyId"
        @click="isExpanded = !isExpanded"
      >
        {{ levelLabel }}
        <span class="material-icons-round" aria-hidden="true">{{ isExpanded ? 'expand_less' : 'expand_more' }}</span>
      </button>
    </h3>
    <div v-show="isExpanded" :id="bodyId" class="p-4 pl-12">
      <label :for="`${uuid}-text`" class="block -ml-8 text-xl font-medium">Annual Target | {{ levelLabel }}</label>
      <p :id="`${uuid}-text-help`" class="mb-1 text-sm text-gray-700">Markdown NOT supported</p>
      <textarea
        :id="`${uuid}-text`"
        v-model="text"
        rows="4"
        :aria-describedby="`${uuid}-text-help`"
        class="w-full px-3 py-2 mb-4 text-md text-gray-900 bg-white border border-gray-600 rounded-xs focus:outline-primary-400"
      />
      <slot />
      <p class="text-right text-sm text-gray-700">
        {{ uuid }}
        <a :href="toolkitUrls.editorLinks.editGoal(uuid)" target="_blank" class="ml-2 text-primary-400 underline">Edit in legacy edit page</a>
      </p>
    </div>
  </section>
</template>
